<template>
  <v-layout row justify-center>
    <v-dialog
      :value="dialog"
      @input="resetDialog()"
      width="500px"
      flat
      scrollable
      persistent
    >

      <v-card flat :color="current_step==DEFINES.ENROLLMENT_STEPS.LOGIN ? 'transparent': null" style="overflow: auto; height: 100%">
        <FeedbackMessage
          v-if="current_step==DEFINES.ENROLLMENT_STEPS.LOGIN"
          type="success"
          :message="$t('login.box.feedback.message.event.standard')">
          </FeedbackMessage>
        <!-- Company Branding -->
        <CompanyBranding v-else
        :company="company"
        ></CompanyBranding>
        <!-- Content -->
        <v-stepper v-model="current_step">
          <v-stepper-items>
            <!-- Ask email -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.LOGIN" class="pt-5">
              <AskEmail
              ref="emailForm"
              :eventPrefix="eventPrefix"
              :email.sync="email"
              @onCancel="resetDialog"
              @onConfirm="checkEmail"
              @loginWithFirebase="loginWithFirebase"
              ></AskEmail>
            </v-stepper-content>

            <!-- Ask passwod if exists -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_PASSWORD">
              <AskPassword
              ref="passwordForm"
              :eventPrefix="eventPrefix"
              :email="email"
              :is_email_verified="is_email_verified"
              :phone="phone"
              :password.sync="password"
              :loading="loading"
              @onChange="goToStep"
              @onReset="resetPassword"
              @onResend="resendVerification"
              @onLoginWithCode="goToStep"
              @onCancel="resetDialog"
              @onConfirm="login"
              ></AskPassword>
            </v-stepper-content>

            <!-- Verification => Ask Otp on email  -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.VERIFICATION">
              <AskOtpOnEmail
              ref="verificationForm"
              :eventPrefix="eventPrefix"
              :phone="phone"
              :email="email"
              :is_email_verified="is_email_verified"
              :code="code"
              @onChange="goToStep"
              @onResend="resendVerification"
              @onSetCode="onComplete"
              @onCancel="resetDialog"
              @onConfirm="verifyOTP"
              ></AskOtpOnEmail>
            </v-stepper-content>

            <!-- Verification => Ask Otp on phone-->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_OTP">
              <AskOtpOnPhone
              ref="verificationForm"
              :eventPrefix="eventPrefix"
              :phone="phone"
              :code="code"
              @onChange="goToStep"
              @onResend="resendVerification"
              @onSetCode="onComplete"
              @onCancel="resetDialog"
              @onConfirm="verifyOTP"
              ></AskOtpOnPhone>
            </v-stepper-content>

            <!-- Ask name & phone -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_NAME_AND_PHONE">
              <AskBasicDetails
              v-if="consumer"
              ref="basicDetailsForm"
              :name.sync="consumer.name"
              :phone.sync="consumer.phone"
              :country_code="country_code"
              @onConfirm="updateConsumer"
              ></AskBasicDetails>
            </v-stepper-content>

            <!-- Ask phone  -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.ASK_PHONE">
              <AskPhone
              :eventPrefix="eventPrefix"
              :country_code="country_code"
              @onChange="goToStep"
              @onSetPhone="setPhoneNumber"
              @onCancel="resetDialog"
              @onConfirm="resetPassword"
              ></AskPhone>
            </v-stepper-content>

            <!-- Ask to set password -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.WANT_TO_SET_PASSWORD">
              <AskToSetPassword
              @onSkip="afterSkipPassword"
              @onConfirm="goToStep"
              ></AskToSetPassword>
            </v-stepper-content>

            <!-- Change password -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.CHANGE_PASSWORD">
              <ChangePassword
              ref="changePasswordForm"
              :eventPrefix="eventPrefix"
              :password.sync="password"
              :confirm_password.sync="confirm_password"
              @onCancel="afterSkipPassword"
              @onConfirm="changePassword"
              ></ChangePassword>
            </v-stepper-content>

            <!-- Select event type - Physical/Virtual -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.SELECT_EVENT_TYPE">
              <EventTypeSelection
              :eventPrefix="eventPrefix"
              :screener="screener"
              :event_type.sync="event_type"
              @onCancel="resetDialog"
              @onConfirm="proceedWithEventType"
              ></EventTypeSelection>
            </v-stepper-content>

            <!-- Select Pricing Plan -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.SELECT_PRICING_PLAN">
              <PricingPlanSelection
              ref="pricingPlanSelectionComp"
              :eventPrefix="eventPrefix"
              :screener="screener"
              @onSetPlan="setPricingPlan"
              @onCancel="resetDialog"
              @onConfirm="validatePricingPlan"
              ></PricingPlanSelection>
            </v-stepper-content>

            <!-- Select seats for event -->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.SELECT_SEATS">
              <PhysicalEventSeatSelection
              :eventPrefix="eventPrefix"
              :screener="screener"
              @onCancel="resetDialog"
              @onConfirm="onAfterSeatsSelection"
              ></PhysicalEventSeatSelection>
            </v-stepper-content>

            <!-- Payment checkout-->
            <v-stepper-content :step="DEFINES.ENROLLMENT_STEPS.PAYMENT" class="pa-0" style="overflow: auto">
              <PaymentCheckout
              :eventPrefix="eventPrefix"
              :pricing="pricing"
              :screener="screener"
              :seats="selectedSeats"
              :event_type="event_type || DEFINES.SCREENER_TYPE_VALUE.VIRTUAL"
              @onSuccess="_afterPurchased"
              @onFailed="resetDialog"
              @onReset="resetDialog"
              >
              <!-- Do not show back button in case of pass and vod purchase -->
              <template
                v-if="modeOfUse !== DEFINES.ENROLLMENT_COMP.MODE_OF_USE.PASS && screener && !screener.is_vod_event"
                v-slot:back-button>
                <v-btn
                color="primary background--text"
                :class="[$vuetify.rtl ? 'ml-2' : '']"
                @click.stop="_backHandler"
                flat
                >{{ $t("screener.btn.back") }}</v-btn>
              </template>
              </PaymentCheckout>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <!-- Paypal donation-->
        <PayPalDonation
        :donationDialog.sync="donationDialog"
        :screener="screener"
        @resetDonationDialog="resetDonationDialog">
        </PayPalDonation>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {EventBus} from '@/event-bus.js';
import DEFINES from "@/defines";
import { mapState, mapGetters } from "vuex";
import { hasGroupTicketPurchased, hasGroupTicketPaymentInProcess} from "@/mixins/monetization";
import { currencySymbol } from "@/mixins/currencySymbol";
import { userCountryCode } from "@/mixins/userCountryCode";
import { consumerAuthentication } from "@/mixins/consumerAuthentication";
import AskEmail from "@/components/screener/enrollment/AskEmail";
import AskPassword from "@/components/screener/enrollment/AskPassword";
import AskOtpOnEmail from "@/components/screener/enrollment/AskOtpOnEmail";
import AskOtpOnPhone from "@/components/screener/enrollment/AskOtpOnPhone";
import AskBasicDetails from "@/components/screener/enrollment/AskBasicDetails";
import AskPhone from "@/components/screener/enrollment/AskPhone";
import AskToSetPassword from "@/components/screener/enrollment/AskToSetPassword";
import ChangePassword from "@/components/screener/enrollment/ChangePassword"
import CompanyBranding from "@/components/company/Branding"
import EventTypeSelection from "@/components/screener/enrollment/EventTypeSelection";
import PricingPlanSelection from "@/components/screener/enrollment/PricingPlanSelection";
import PhysicalEventSeatSelection from "@/components/screener/enrollment/SeatSelection";
import PaymentCheckout from "@/components/screener/enrollment/PaymentCheckout"
import PayPalDonation from "@/components/monetization/PayPalDonation";
import FeedbackMessage from "@/components/FeedbackMessage"

export default {
  name: "Enrollment",
  props: {
    screener: {
      type: Object,
      default: null
    },
    dialog: {
      type: Boolean,
      default: true
    },
    modeOfUse: {
      type: String,
      default: null
    },
    pass: {
      type: Object,
      default: null
    },
    eventPrefix: {
      type: String,
      default: 'screener'
    },
    plan:{
      type: Object,
      default: null
    }
  },
  components: {
    AskEmail,
    AskPassword,
    AskOtpOnEmail,
    AskOtpOnPhone,
    AskBasicDetails,
    AskPhone,
    AskToSetPassword,
    ChangePassword,
    CompanyBranding,
    EventTypeSelection,
    PricingPlanSelection,
    PhysicalEventSeatSelection,
    PaymentCheckout,
    PayPalDonation,
    FeedbackMessage
  },
  data() {
    return {
      current_step: this.DEFINES.ENROLLMENT_STEPS.LOGIN,
      is_email_verified: false,
      email: "",
      phone: null,
      password: "",
      confirm_password: "",
      otp: null,
      donationDialog: false,
      loading: false,
      country_code: DEFINES.DEFAULT_COUNTRY_CODE,
      otp:null,
      code:null,
      resettingPassword:false,
      isPhoneValid:false,
      pricing:null,
      event_type:null, // Remem::Can not set default value bcoz need to validate either user selected event type or not, if not then ask.
      selectedSeats:[],
    };
  },
  watch: {
    dialog: function (newValue, oldValue) {
      if (newValue) {
        this.initiateEnrollment();
      }
    },
    current_step(value){
        switch (value) {
          case DEFINES.ENROLLMENT_STEPS.ASK_PHONE:
            this.getCountryCode();
            break;
          case DEFINES.ENROLLMENT_STEPS.ASK_NAME_AND_PHONE:
            this.getCountryCode();
            break;
          default:
            break;
        }
    }
  },
  mixins: [currencySymbol, hasGroupTicketPurchased, userCountryCode, consumerAuthentication, hasGroupTicketPaymentInProcess],
  computed: {
    ...mapState({
      company: (state) => state.company.company,
      session_key: (state) => state.auth.key,
      consumer: (state) => state.consumer.profile,
    }),
    ...mapGetters("app", {
      isLoggedIn: "isLoggedIn",
    }),
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid",
    }),
    ...mapGetters("consumer", {
      isConsumerPurchased: "isPurchased",
      isConsumerEnrolled: "isEnrolled",
      isPaymentInProcess:"isPaymentInProcess",
      isConsumerSubscribed: "isSubscribed"
    }),
    ...mapGetters("company", {
      currentCompanyID: "getNavigationParamOfCompany",
    }),
    ...mapGetters("auth", {
      isPreviewUser:"isPreviewMode"
    }),
    ...mapGetters("subscription", {
      isSubscriptionActive:"isSubscriptionActive"
    })
  },
  methods: {
    async getCountryCode() {
      this.country_code = await this.getUserCountryCode();
    },
    onComplete(code) {
      this.otp = code;
      this.verifyOTP();
    },
    /* Handling of back button */
    _backHandler(){
      var event_type = this.event_type;

      /* If event type not availble, check if the event paid & available in Virtual mode only */
      if(!event_type){
        event_type = this.screener && this.isScreeningPaid(this.screener) ? this.screener.event_type : null;
      }

      switch (event_type) {
        case DEFINES.SCREENER_TYPE_VALUE.VIRTUAL:
          return this.goToStep(DEFINES.ENROLLMENT_STEPS.SELECT_PRICING_PLAN);
        case DEFINES.SCREENER_TYPE_VALUE.PHYSICAL:
          return EventBus.$emit("showSeatChart");
        default:
          break;
      }
    },
    async _afterPurchased(response = {}){
        // Auto enroll only for single pricing plan
        if (this.pricing &&
          (this.pricing.type == DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE ||
          this.pricing.type == DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE)
        ) {
          this.enrollToScreening(response);
        }

        if(this.event_type == DEFINES.SCREENER_TYPE_VALUE.PHYSICAL)
        {
          this.bookingSuccess(response);
        }

        /**
         * show custom message if any payment gateway wants to send in case of pass purchase
         */
        if(this.pricing &&
          this.pricing.type == DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE &&
          response &&
          response.customMessage ){
          await this.$store.dispatch("app/showMessage", {
            message: response.customMessage,
            color: "success",
          });
        }

        // Reset affiliation if any
        this.resetAffiliation();
        this.resetDialog();
        // Go to dashboard once purchasing done
        if(!this._isDonationAvailable()){
          this.handleRedirection();
        }
    },
    async resetAffiliation(){
        try {
          await this.$store.dispatch("affiliation/reset",{});
        } catch (error) {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: 'error',
          });
        }
    },
    async bookingSuccess(paymentResponse){
        let successMessage = (paymentResponse && paymentResponse.customMessage)
            ? paymentResponse.customMessage
            : this.$t(`${this.eventPrefix}.booking.success`,{
            accountLink: this._getRouteFullURL('user.dashboard',{},{tab: "tickets"}),
            calculatedDescriptor: this._calculatedPaymentStatementDescriptor()
            });

        await this.$store.dispatch("app/showMessage", {
          message: successMessage,
          color: "success",
        });
    },
    handleRedirection()
    {
        if(this.$route.name == "screeners.overview")
        {
          return;
        }
        if(this.modeOfUse == DEFINES.ENROLLMENT_COMP.MODE_OF_USE.SUBSCRIPTION){
          return this.$router.push({ name: "subscription.success" });
        }
        if(!(this.$route.query && this.$route.query.allowEmbed)){
          this.goToConsumerDashboard();
        }
    },
    initiateEnrollment() {
      try {
        // console.log("initiating the process");
        if (this.isPreviewUser) {
          this.$store.dispatch("auth/logout", {});
        }


        /*
        * 1.Login is not required for physical tickets
        *
        * Ask to select event type - Physical/Virtual
        */
        if(!this.isLoggedIn && this.screener && this.screener.event_type && this.screener.event_type >= DEFINES.SCREENER_TYPE_VALUE.PHYSICAL && !this.event_type){
          return this._askForEventType();
        }

        /**
         * 1. IF not logged in then start with first step
         */
        if (!this.isLoggedIn) {
          // console.log("Redirecting to Login");
          return this.goToStep(DEFINES.ENROLLMENT_STEPS.LOGIN);
        }

        /* Ask to select event type - Physical/Virtual*/
        if(this.screener && this.screener.event_type && this.screener.event_type >= DEFINES.SCREENER_TYPE_VALUE.PHYSICAL && !this.event_type){
          return this._askForEventType();
        }

        /* In case the user not selected any plan  */
        if (
          this.screener &&
          !this.screener.is_vod_event &&
          this.isScreeningPaid(this.screener) &&
          !this.isConsumerPurchased(this.screener.id) &&
          !this.pricing
        ) {
          return this.goToStep(DEFINES.ENROLLMENT_STEPS.SELECT_PRICING_PLAN);
        }

        /**
         * In case of VOD screenings
         * 1. Directly assign the plan (without selection of radio button)
         */
        if(this.screener && this.screener.is_vod_event && !this.isConsumerSubscribed){
          this.pricing = this.screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE][0]
        }

        /* User selected plan but that plan didn't have the selected screening in it */
        if (
          this.screener &&
          this.pricing &&
          this.pricing.screening_ids.indexOf(this.screener.id) == -1
        ) {
          throw {
            message: this.$t(`${this.eventPrefix}.monetization.selected_wrong_plan`),
          };
        }

        /* Handling of pass purchase */
        if(this.modeOfUse){
          switch (this.modeOfUse) {
            case DEFINES.ENROLLMENT_COMP.MODE_OF_USE.PASS:
              this.pricing = this.pass;
              break;
            case DEFINES.ENROLLMENT_COMP.MODE_OF_USE.SUBSCRIPTION:
              /* Because, Payment Checkout accepts pricing prop */
              this.pricing = this.plan; /* Vod Subscription Plan */
              this.event_type = DEFINES.SCREENER_TYPE_VALUE.SUBSCRIPTION;
            break;
            default:
              break;
          }
        }

        //payment is in process so give error and don't allow user to pay for the same again
        if (
          (this.screener && !this.isConsumerPurchased(this.screener.id) && this.isPaymentInProcess(this.screener.id))
          ||
          (this.pricing && !this.hasGroupTicketPurchased(this.pricing.id) && this.hasGroupTicketPaymentInProcess(this.pricing.id)
          )
        ) {
          throw {
            message: this.$t(`${this.eventPrefix}.monetization.payment_is_in_process`),
          };
        }

        /**
         * 2. If loggen in and screening is paid or ticker has not been purchased yet then
         *  Ask for payment
         */
        if (this.pricing) {
          switch (this.pricing.type) {
            case DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE:
              if (
                this.isScreeningPaid(this.screener) &&
                !this.isConsumerPurchased(this.screener.id)
              ) {
                // console.log("Asking for screening's payemnt");
                return this.goToStep(DEFINES.ENROLLMENT_STEPS.PAYMENT);
              }
              break;
            case DEFINES.MONETIZATION.PRICING_TYPE.GROUP_PURCHASE:
              /*
                It may be possible that user selects group pricing but
                clicking on free screening's participate button
              */
              if (this.screener && !this.isScreeningPaid(this.screener)) {
                break;
              }
              if (!this.hasGroupTicketPurchased(this.pricing.id)) {
                // console.log("Asking for pass payemnt");
                return this.goToStep(DEFINES.ENROLLMENT_STEPS.PAYMENT);
              }
              break;
            case DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE:
              if (
                this.isScreeningPaid(this.screener) &&
                !this.isConsumerPurchased(this.screener.id)
              ) {
                // console.log("Asking for vod event payemnt");
                return this.goToStep(DEFINES.ENROLLMENT_STEPS.PAYMENT);
              }
              break;
            case DEFINES.MONETIZATION.PRICING_TYPE.PHYSICAL_TICKET_PURCHASE:
              if (
                this.isScreeningPaid(this.screener) &&
                !this.isConsumerPurchased(this.screener.id)
              ) {
                // console.log("Asking for vod event payemnt");
                return this.goToStep(DEFINES.ENROLLMENT_STEPS.PAYMENT);
              }
            case DEFINES.MONETIZATION.PRICING_TYPE.SUBSCRIPTION:
              return ((!this.isConsumerSubscribed)?this.goToStep(DEFINES.ENROLLMENT_STEPS.PAYMENT):this.goToConsumerDashboard(null, "subscription"));
            default:
              break;
          }
        }

        /**
         * 2. If logged in and event type is physical type
         * then only trigger the payment
         */
        if(this.screener &&
          this.event_type==DEFINES.SCREENER_TYPE_VALUE.PHYSICAL &&
          !this.isConsumerPurchased(this.screener.id)){
            return this.goToStep(DEFINES.ENROLLMENT_STEPS.PAYMENT);
          }

        /**
         * 3. If logged in and not enrolled
         */
        if (
          this.screener &&
          !this.isConsumerEnrolled(this.screener.id) &&
          (!this.isScreeningPaid(this.screener) ||
            this.isConsumerPurchased(this.screener.id) || (this.screener.is_vod_event && this.isConsumerSubscribed))
        ) {
          // console.log("Enrolling to screening");
          /* Enrolling consumer to screening */
          this.enrollToScreening();
        }

        this.resetDialog();
        // console.log("Redirecting to Dashboard");
        /* After enrolling, redirect to dashboard  */
        if(!this._isDonationAvailable()){
          this.handleRedirection();
        }
      } catch (error) {
        this.resetDialog();
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: error.color ? error.color : 'error',
        });
      }
    },
    _askForEventType(){
      switch (this.screener.event_type) {
        case DEFINES.SCREENER_TYPE_VALUE.VIRTUAL_AND_PHYSICAL:
            if(this._shouldAskForEventTypeSelection())
            {
              return this.goToStep(DEFINES.ENROLLMENT_STEPS.SELECT_EVENT_TYPE);
            }
            return this._handlePhysicalTypeEvent();
        case DEFINES.SCREENER_TYPE_VALUE.PHYSICAL:
            return this._handlePhysicalTypeEvent();
        default:
            break;
      }
    },
    _shouldAskForEventTypeSelection(){
      // If event is geo blocked, do not ask
      if(this.screener && this.screener.is_geo_blocked){
        return false;
      }
      // If event is paid but not purchased then ask
      if(this.isScreeningPaid(this.screener) && !this.isConsumerPurchased(this.screener.id))
      {
        return true;
      }
      // If event free/paid but not enrolled then ask
      if(!this.isConsumerEnrolled(this.screener.id)){
        return true;
      }
    },
    _handlePhysicalTypeEvent(){
      this.event_type = DEFINES.SCREENER_TYPE_VALUE.PHYSICAL;
      return this.proceedWithEventType();
    },
    _isDonationAvailable(){
      return this.screener && this.screener.donation_enabled;
    },
    async verifyOTP() {
      try {
        if (!this.$refs.verificationForm.validate()) {
          return false;
        }
        await this.$store
          .dispatch("auth/verifyOTP", {
            otp: this.otp,
            key: this.session_key,
            company_id: this.company.id,
          })
          .then(async (response) => {
            /* Load consumer active subscription if any */
            await this.getConsumerSubscription();
            if(response.consumer && !response.consumer.name)
            {
              return this.goToStep(DEFINES.ENROLLMENT_STEPS.ASK_NAME_AND_PHONE);
            }
            if ((!response.has_password && !response.consumer.is_password_skipped) || this.resettingPassword) {
              this.goToStep(DEFINES.ENROLLMENT_STEPS.WANT_TO_SET_PASSWORD);
            } else {
              this.initiateEnrollment();
            }
          });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async loginWithFirebase(payload)
        {
            await this.$store.dispatch('auth/loginWithFirebase',{
              provider: 'google', //Using google provider by default
              accessToken: payload.credential.idToken,
              company_id: this.company.id,
            })
            .then((response) => {
              // After successfull login process to new step
              this.initiateEnrollment();
            })
            .catch((error) => {
              this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
              });
            })
        },
    async login() {
      try {
        if (!this.$refs.passwordForm.validate()) {
          return false;
        }
        this.loading = true;
        await this.$store
          .dispatch("auth/login", {
            email: this.email,
            password: this.password,
            company_id: this.company.id,
          })
          .then((response) => {
            this.loading = false;
            this.initiateEnrollment();
          });
      } catch (error) {
        this.loading = false;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async changePassword() {
      try {
        if (!this.$refs.changePasswordForm.validate()) {
          return false;
        }
        this.matchPasswords();
        await this.$store
          .dispatch("consumer/changePassword", {
            password: this.password,
          })
          .then((response) => {
            this.resettingPassword = false;
            this.initiateEnrollment();
          });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async afterSkipPassword() {
      if(!this.consumer.is_password_skipped){
        this.consumer.is_password_skipped = true;
        this.doUpdateConsumer();
      }
      this.resettingPassword = false;
      this.initiateEnrollment();
    },
    _calculatedPaymentStatementDescriptor(){
      return this.$t(this.DEFINES.PAYMENT_GATEWAYS.STRIPE.statement_descriptor)+" "+this.$t(this.company.payment_setting.stripe.statement_descriptor_suffix);
    },
    async enrollToScreening(paymentResponse) {
      try {
        let isShowingCustomMessage = false;
        if((paymentResponse && paymentResponse.customMessage)){
          isShowingCustomMessage = true;
        }
        if(!isShowingCustomMessage){
          let response = await this.$store.dispatch(
            "consumer/enrollToScreening",
            {
              screener_id: this.screener.id,
            }
          );
        }
        
        if(this._isDonationAvailable()){
          this.donationDialog = true;
        }
        /**
         * Redirect to Watch after enrolling
         * ->if event is vod and the user have active subscription
         */
        else if(this.screener && this.screener.is_vod_event && this.isSubscriptionActive) {
          this.goToWatchPage();
        }else{
          let successMessage = isShowingCustomMessage
            ? paymentResponse.customMessage
            : this.$t(`${this.eventPrefix}.enrolled_success`, {
                accountLink: this._getRouteFullURL(
                  'user.dashboard',
                  {},
                  {tab: 'events'}
                ),
                payment_message:
                  (this.screener && this.isScreeningPaid(this.screener)) ||
                  this.pass
                    ? this.$t('screener.payment_message', {
                        calculatedDescriptor: this._calculatedPaymentStatementDescriptor(),
                      })
                    : '',
            });

            await this.$store.dispatch("app/showMessage", {
              message: successMessage,
              color: "success",
            });
        }

        this.resetDialog();

        // Redirect to watch page in fireplace_ad VOD event
        if( !isShowingCustomMessage && this.company.id == DEFINES.FIREPLACE_AD_COMPANY_ID && this.screener.id == DEFINES.FIREPLACE_AD_SCREENER_ID){
          this.$emit('onPurchased',this.screener)
        }
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    goToConsumerDashboard(query =null, tab=null) {
      /**
       * Go to dashboard with specific tab
       */
      let initial_tab_route = tab ? tab : ( this.screener && this.screener.is_vod_event ) ? 'vodEvents' :'events'
      this.$router.push({
        name: "user.dashboard",
        query: {
          tab: initial_tab_route
        }
      });
    },
    goToWatchPage() {
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: this.screener.id
        }
      });
    },
    resetDialog() {
      this.$emit("update:dialog", false);
      this.resetPricingPlan();
      this.resetEventType();
      this.resetSelectedSeats();
      // this.$emit("update:screener", null);
    },
    resetSelectedSeats(){
      this.selectedSeats = [];
    },
    resetPricingPlan(){
      this.pricing = null;
      if(this.$refs.pricingPlanSelectionComp){
        this.$refs.pricingPlanSelectionComp.reset();
      }
    },
    resetDonationDialog(){
      this.donationDialog = false;
    },
    resetEventType(){
      this.event_type = null
    },
    setPhoneNumber(payload) {
      if (payload.formattedNumber) {
        this.phone = payload.formattedNumber;
        this.isPhoneValid = payload.isValid;
      }
    },
    setPricingPlan(plan) {
      this.pricing = plan;
    },
    validatePricingPlan(){
      try {
        if(!this.pricing){
          throw {
            message: this.$t(`${this.eventPrefix}.monetization.plan_required`),
          };
        }
        this.initiateEnrollment();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    proceedWithEventType(){
      if(!this.event_type){
        return;
      }
      switch (this.event_type) {
        case DEFINES.SCREENER_TYPE_VALUE.VIRTUAL:
            this.initiateEnrollment();
          break;
        case DEFINES.SCREENER_TYPE_VALUE.PHYSICAL:
            // this.goToStep(DEFINES.ENROLLMENT_STEPS.SELECT_SEATS);
            EventBus.$emit("showSeatChart");
          break;
        default:
          break;
      }
    },
    onAfterSeatsSelection(seats){
      this.selectedSeats = seats;
       if (!this.isLoggedIn) {
          // console.log("Redirecting to Login");
          return this.goToStep(DEFINES.ENROLLMENT_STEPS.LOGIN);
        }

        return this.goToStep(DEFINES.ENROLLMENT_STEPS.PAYMENT)
    },
    goToStep(step){
      this.current_step = step;
    },
    _getRouteFullURL(routeName,params={},query={}){
      let props = this.$router.resolve ({
        name: routeName,
        params:params,
        query: query,
      });
      return props.href;
    },
    async getConsumerSubscription(){
      if (!this.isLoggedIn) {
        return;
      }
      try {
        /* Getting it on layout mount so that any refund made reflects */
        await this.$store.dispatch("subscription/get", {
          company_id: this.company && this.company.id,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>
